export enum MonthlyInstallments {
	MONTHS_24 = 24,
	MONTHS_36 = 36,
}
